/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientCompanyViewModel } from '../models/client-company-view-model';
import { ClientModel } from '../models/client-model';
import { ClientStatusViewModel } from '../models/client-status-view-model';
import { ClientSystemFeatureStatusViewModel } from '../models/client-system-feature-status-view-model';
import { ClientSystemSettingViewModel } from '../models/client-system-setting-view-model';
import { ClientViewModelPrimeDatatableResults } from '../models/client-view-model-prime-datatable-results';
import { Delete } from '../fn/clients/delete';
import { Delete$Params } from '../fn/clients/delete';
import { DownloadClientPhoto } from '../fn/clients/download-client-photo';
import { DownloadClientPhoto$Params } from '../fn/clients/download-client-photo';
import { Get } from '../fn/clients/get';
import { Get$Params } from '../fn/clients/get';
import { GetClientCompanies } from '../fn/clients/get-client-companies';
import { GetClientCompanies$Params } from '../fn/clients/get-client-companies';
import { GetClientFormOptions } from '../fn/clients/get-client-form-options';
import { GetClientFormOptions$Params } from '../fn/clients/get-client-form-options';
import { GetClientSystemFeatureStatuses } from '../fn/clients/get-client-system-feature-statuses';
import { GetClientSystemFeatureStatuses$Params } from '../fn/clients/get-client-system-feature-statuses';
import { GetClientSystemSettings } from '../fn/clients/get-client-system-settings';
import { GetClientSystemSettings$Params } from '../fn/clients/get-client-system-settings';
import { GetImpersonationLink } from '../fn/clients/get-impersonation-link';
import { GetImpersonationLink$Params } from '../fn/clients/get-impersonation-link';
import { List } from '../fn/clients/list';
import { List$Params } from '../fn/clients/list';
import { ListItem } from '../models/list-item';
import { Save } from '../fn/clients/save';
import { Save$Params } from '../fn/clients/save';
import { SaveClientCompany } from '../fn/clients/save-client-company';
import { SaveClientCompany$Params } from '../fn/clients/save-client-company';
import { SaveClientSystemFeatureStatus } from '../fn/clients/save-client-system-feature-status';
import { SaveClientSystemFeatureStatus$Params } from '../fn/clients/save-client-system-feature-status';
import { SaveClientSystemSetting } from '../fn/clients/save-client-system-setting';
import { SaveClientSystemSetting$Params } from '../fn/clients/save-client-system-setting';
import { Status } from '../fn/clients/status';
import { Status$Params } from '../fn/clients/status';
import { UploadClientSystemSetting } from '../fn/clients/upload-client-system-setting';
import { UploadClientSystemSetting$Params } from '../fn/clients/upload-client-system-setting';

@Injectable({ providedIn: 'root' })
export class ClientsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiClientsListPost()` */
  static readonly ApiClientsListPostPath = '/api/Clients/List';

  /**
   * List Clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * List Clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<ClientViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientViewModelPrimeDatatableResults>): ClientViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiClientsGetPost()` */
  static readonly ApiClientsGetPostPath = '/api/Clients/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<ClientModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientModel>): ClientModel => r.body)
    );
  }

  /** Path part for operation `apiClientsStatusClientIdGet()` */
  static readonly ApiClientsStatusClientIdGetPath = '/api/Clients/Status/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Status()` instead.
   *
   * This method doesn't expect any request body.
   */
  Status$Response(params: Status$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientStatusViewModel>> {
    return Status(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Status$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Status(params: Status$Params, context?: HttpContext): Observable<ClientStatusViewModel> {
    return this.Status$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientStatusViewModel>): ClientStatusViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsSavePost()` */
  static readonly ApiClientsSavePostPath = '/api/Clients/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<ClientModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientModel>): ClientModel => r.body)
    );
  }

  /** Path part for operation `apiClientsDeletePost()` */
  static readonly ApiClientsDeletePostPath = '/api/Clients/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Delete()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete$Response(params?: Delete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Delete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Delete$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete(params?: Delete$Params, context?: HttpContext): Observable<void> {
    return this.Delete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsGetImpersonationLinkPost()` */
  static readonly ApiClientsGetImpersonationLinkPostPath = '/api/Clients/GetImpersonationLink';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetImpersonationLink()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetImpersonationLink$Response(params?: GetImpersonationLink$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetImpersonationLink(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetImpersonationLink$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetImpersonationLink(params?: GetImpersonationLink$Params, context?: HttpContext): Observable<string> {
    return this.GetImpersonationLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientCompaniesClientIdPost()` */
  static readonly ApiClientsGetClientCompaniesClientIdPostPath = '/api/Clients/GetClientCompanies/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientCompanies()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientCompanies$Response(params: GetClientCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientCompanyViewModel>>> {
    return GetClientCompanies(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientCompanies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientCompanies(params: GetClientCompanies$Params, context?: HttpContext): Observable<Array<ClientCompanyViewModel>> {
    return this.GetClientCompanies$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientCompanyViewModel>>): Array<ClientCompanyViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientCompanyClientIdPost()` */
  static readonly ApiClientsSaveClientCompanyClientIdPostPath = '/api/Clients/SaveClientCompany/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientCompany()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientCompany$Response(params: SaveClientCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCompanyViewModel>> {
    return SaveClientCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientCompany$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientCompany(params: SaveClientCompany$Params, context?: HttpContext): Observable<ClientCompanyViewModel> {
    return this.SaveClientCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientCompanyViewModel>): ClientCompanyViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientSystemFeatureStatusesClientIdPost()` */
  static readonly ApiClientsGetClientSystemFeatureStatusesClientIdPostPath = '/api/Clients/GetClientSystemFeatureStatuses/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientSystemFeatureStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientSystemFeatureStatuses$Response(params: GetClientSystemFeatureStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSystemFeatureStatusViewModel>>> {
    return GetClientSystemFeatureStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientSystemFeatureStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientSystemFeatureStatuses(params: GetClientSystemFeatureStatuses$Params, context?: HttpContext): Observable<Array<ClientSystemFeatureStatusViewModel>> {
    return this.GetClientSystemFeatureStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSystemFeatureStatusViewModel>>): Array<ClientSystemFeatureStatusViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientSystemFeatureStatusClientIdPost()` */
  static readonly ApiClientsSaveClientSystemFeatureStatusClientIdPostPath = '/api/Clients/SaveClientSystemFeatureStatus/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientSystemFeatureStatus()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientSystemFeatureStatus$Response(params: SaveClientSystemFeatureStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSystemFeatureStatusViewModel>> {
    return SaveClientSystemFeatureStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientSystemFeatureStatus$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientSystemFeatureStatus(params: SaveClientSystemFeatureStatus$Params, context?: HttpContext): Observable<ClientSystemFeatureStatusViewModel> {
    return this.SaveClientSystemFeatureStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSystemFeatureStatusViewModel>): ClientSystemFeatureStatusViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientSystemSettingsClientIdPost()` */
  static readonly ApiClientsGetClientSystemSettingsClientIdPostPath = '/api/Clients/GetClientSystemSettings/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientSystemSettings()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientSystemSettings$Response(params: GetClientSystemSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSystemSettingViewModel>>> {
    return GetClientSystemSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientSystemSettings$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientSystemSettings(params: GetClientSystemSettings$Params, context?: HttpContext): Observable<Array<ClientSystemSettingViewModel>> {
    return this.GetClientSystemSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSystemSettingViewModel>>): Array<ClientSystemSettingViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientSystemSettingClientIdPost()` */
  static readonly ApiClientsSaveClientSystemSettingClientIdPostPath = '/api/Clients/SaveClientSystemSetting/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientSystemSetting()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientSystemSetting$Response(params: SaveClientSystemSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveClientSystemSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientSystemSetting$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientSystemSetting(params: SaveClientSystemSetting$Params, context?: HttpContext): Observable<void> {
    return this.SaveClientSystemSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsUploadClientSystemSettingClientIdPost()` */
  static readonly ApiClientsUploadClientSystemSettingClientIdPostPath = '/api/Clients/UploadClientSystemSetting/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UploadClientSystemSetting()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadClientSystemSetting$Response(params: UploadClientSystemSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UploadClientSystemSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UploadClientSystemSetting$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadClientSystemSetting(params: UploadClientSystemSetting$Params, context?: HttpContext): Observable<void> {
    return this.UploadClientSystemSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientFormOptionsClientIdPost()` */
  static readonly ApiClientsGetClientFormOptionsClientIdPostPath = '/api/Clients/GetClientFormOptions/{clientID}';

  /**
   * Get Client Form Options for System Settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientFormOptions()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientFormOptions$Response(params: GetClientFormOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListItem>>> {
    return GetClientFormOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Client Form Options for System Settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientFormOptions$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientFormOptions(params: GetClientFormOptions$Params, context?: HttpContext): Observable<Array<ListItem>> {
    return this.GetClientFormOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ListItem>>): Array<ListItem> => r.body)
    );
  }

  /** Path part for operation `apiClientsDownloadClientPhotoClientIdPost()` */
  static readonly ApiClientsDownloadClientPhotoClientIdPostPath = '/api/Clients/DownloadClientPhoto/{clientID}';

  /**
   * Download Client Photo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DownloadClientPhoto()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DownloadClientPhoto$Response(params: DownloadClientPhoto$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return DownloadClientPhoto(this.http, this.rootUrl, params, context);
  }

  /**
   * Download Client Photo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DownloadClientPhoto$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DownloadClientPhoto(params: DownloadClientPhoto$Params, context?: HttpContext): Observable<Blob> {
    return this.DownloadClientPhoto$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
